import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

export const URL_SERVER = 'https://mobitoken.site/api'

export async function getRequest(url, token=null){
    const headers = {
              'Accept-Language': 'en-GB',
              'RequestId': uuidv4(),
              }
    if(token){
        headers['Authorization'] = "Bearer " + token
    }

    try {
         const response = await axios.get(url, {
            headers: headers
         })
         return response.data
    }
    catch(error) {
          if (error.response) {
            return error.response.data;
          } else if (error.request) {
            console.error('Axios Error request:', error.request);
          } else {
            console.error('Axios Unknown Error', error.message);
          }
    }
}

export async function postRequest(url, data, token=null){
    const headers = {
              'Access-Control-Allow-Origin': "*",
              'Content-Type': 'application/json',
              'Accept-Language': 'en-GB',
              'RequestId': uuidv4(),
              }
    if(token){
        headers['Authorization'] = "Bearer " + token
    }
    try {
         const response = await axios.post(url, data, {
            headers: headers
         })
         return response.data
    }
    catch(error) {
          if (error.response) {
            return error.response.data;
          } else if (error.request) {
            console.error('Axios Error request:', error.request);
          } else {
            console.error('Axios Unknown Error', error.message);
          }
    }
}

export async function getPhotoSource(photoId, token){
  const headers = {
            'Accept-Language': 'en-GB',
            'RequestId': uuidv4(),
            }
  if(token){
      headers['Authorization'] = "Bearer " + token
  }

    try {

    const response = fetch(URL_SERVER + '/file/download/' + photoId, {
      method: 'GET',
      headers: headers
    })
      return response;
  } catch (error) {
    console.log(error)
  }
}
